"use client";

import InferenceSegmentation from "./inference-segmentation";
import { Segment } from "./prompt-types";
import { InferenceStatus, SegmentResult } from "@/lib/playground-utils";

type InferenceSegmentationMultiProps = {
  image: string;
  result: string;
  query: string;
  duration?: number;
  status?: InferenceStatus;
  segmentResult?: SegmentResult;
  segmentResults?: SegmentResult[];
  neonHue?: number;
  imageFile?: File;
};

export default function InferenceSegmentationMulti(props: InferenceSegmentationMultiProps) {
  return (
    <InferenceSegmentation
      {...props}
      displayCapability={Segment}
      segmentResults={props.segmentResults}
    />
  );
}
